var _circle, _circle2, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgopadMobBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 357,
    viewBox: "0 0 356 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 178.767,
    r: 167.788,
    stroke: "#D7544F",
    strokeWidth: 4.10821
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 178.767,
    r: 176.768,
    stroke: "#D7544F",
    strokeWidth: 2.46493
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 271.922,
    y: 37.3433,
    width: 5.9147,
    height: 0.733018,
    transform: "rotate(-56.4942 271.922 37.3433)",
    fill: "url(#paint0_linear_43_571)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 259.457,
    y: 51.9058,
    width: 15.0481,
    height: 1.8112,
    transform: "rotate(-57.1098 259.457 51.9058)",
    fill: "url(#paint1_linear_43_571)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_571",
    x1: 274.879,
    y1: 37.3433,
    x2: 274.879,
    y2: 38.0763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_571",
    x1: 266.981,
    y1: 51.9058,
    x2: 266.981,
    y2: 53.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgopadMobBg);
export default __webpack_public_path__ + "static/media/algopad-mob-bg.f87f304da2547cb41ea0bb7d9f55d3d5.svg";
export { ForwardRef as ReactComponent };